import { useCallback } from 'react'
import { useAppDispatch } from '@/state'
import { FormStatusType } from '@/enums/form-status.enum'

import { setFormModeAction } from '@/state/ui/global/slices/index.slices'
import {
  GetTransactionsPayload,
  TransactionWalletsLibraryColumnProps,
  Transactions,
  TransactionsFilters,
} from '@/state/transactions/models'
import { TransactionsActions } from '@/state/transactions/slices/index.slices'

import { getAllTransactionsThunk } from '@/state/transactions/thunks/get-all.thunk'
import { TableHeadCellPropsType } from '@/state/ui/global/models'
import { exportXlsxFile } from '@/utils'

export const useTransactionsActions = () => {
  const dispatch = useAppDispatch()

  const getAllTransactions = async (
    filters: GetTransactionsPayload,
    headCells?: TableHeadCellPropsType<TransactionWalletsLibraryColumnProps>[],
    fileName?: string,
    getFormattedRow?: (
      row: Transactions,
    ) => TransactionWalletsLibraryColumnProps,
  ) => {
    const resultAction = await dispatch(
      getAllTransactionsThunk({
        ...filters,
      }),
    )

    if (
      getFormattedRow &&
      headCells &&
      getAllTransactionsThunk.fulfilled.match(resultAction)
    ) {
      exportXlsxFile(
        headCells,
        resultAction.payload.docs.map((item) => getFormattedRow(item)),
        fileName,
      )
    }
  }

  const setFormType = useCallback(
    (formMode: FormStatusType) => dispatch(setFormModeAction(formMode)),
    [dispatch],
  )

  const setTransactionsFilters = useCallback(
    (filters: TransactionsFilters) =>
      dispatch(TransactionsActions.setTransactionFiltersAction(filters)),
    [dispatch],
  )

  const cleanTransactions = useCallback(
    () => dispatch(TransactionsActions.cleanTransactionsAction()),
    [dispatch],
  )

  return {
    getAllTransactions,
    setFormType,
    setTransactionsFilters,
    cleanTransactions,
  }
}
